// extracted by mini-css-extract-plugin
export var product = "ProductLinks-module--product--2Yk7F";
export var product_blue = "ProductLinks-module--product_blue--RbUCu";
export var product_green = "ProductLinks-module--product_green--YJt4D";
export var arrow = "ProductLinks-module--arrow--myAYQ";
export var icon = "ProductLinks-module--icon--QLihn";